import { Component, OnDestroy } from '@angular/core';
import { RealEstate } from '../../models/real-estate.model';
import { AdCategories } from '../../models/ad-categories.model';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Plans } from '../../shared/constants/plan.constants';
import { Statuses } from '../../shared/constants/status.constants';
import { selectIsArabic } from '../../store/selectors/language.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import {
  selectRealEstate,
  selectRealEstateState,
} from '../../store/selectors/real-estate.selectors';
import { loadCategories } from '../../store/actions/categories.actions';
import {
  getRealEstate,
  removeRealEstate,
  setRealEstateSold,
} from '../../store/actions/real-estate.actions';
import { selectIsLoggedIn } from '../../store/selectors/auth.selectors';
declare var bootstrap: any;
import * as L from 'leaflet';

@Component({
  selector: 'app-property-details',
  standalone: false,
  templateUrl: './property-details.component.html',
  styleUrl: './property-details.component.scss',
})
export class PropertyDetailsComponent implements OnDestroy {
  property?: RealEstate;
  loading = false;
  deleting = false;

  property$!: Observable<RealEstate | undefined>;

  currentImage = '';
  currentImageIndex = 0;
  modalInstance: any;

  copied = false;

  plans = Plans;
  statuses = Statuses;

  deleteReasons = [
    'PROPERTY_DELETE_OPTION_SOLD',
    'PROPERTY_DELETE_OPTION_NO_MORE_SELL',
    'DELETE_OPTION_OTHER',
  ];

  customIcon = L.icon({
    iconUrl: 'icons/home.png',
    iconSize: [18, 18],
    iconAnchor: [10, 7],
  });

  selectedReason: string | null = null;

  isArabic$: Observable<boolean> = this.store.select(selectIsArabic);
  isUserLoggedIn$ = this.store.select(selectIsLoggedIn);

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private location: Location
  ) {
    this.property$ = this.store.select(selectRealEstate);
    this.store.dispatch(loadCategories());
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((paramMap) => {
      const propertyId = Number(paramMap.get('id'));
      this.fetchProperty(propertyId);
    });
  }

  fetchProperty(id: number): void {
    this.loading = true;

    this.store.dispatch(getRealEstate({ realEstateId: id }));
    this.property$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (property) => {
        this.property = property;
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load property', err);
        this.loading = false;
      },
    });
  }

  getCarImageUrl(model: string): string {
    return encodeURI(model.toLowerCase());
  }

  editProperty() {
    this.router.navigate(['/add-property/', this.property?.id]);
  }

  goBack() {
    this.location.back();
  }

  deleteProperty() {
    if (this.property?.id) {
      this.deleting = true;
      if (this.property.status === Statuses.Sold) {
        this.store.dispatch(removeRealEstate({ id: this.property?.id }));
      }
      if (!this.selectedReason) {
        return;
      }

      if (this.selectedReason === 'PROPERTY_DELETE_OPTION_SOLD') {
        this.store.dispatch(setRealEstateSold({ realEstateId: this.property?.id }));
      } else {
        this.store.dispatch(removeRealEstate({ id: this.property?.id }));
      }
      this.store
        .select(selectRealEstateState)
        .pipe(takeUntil(this.destroy$))
        .subscribe(({ isSaving, error }) => {
          if (!isSaving && !error) {
            this.property = undefined;
            this.router.navigate(['./']);
            this.deleting = false;
            this.closeDeleteModal();
          } else if (!isSaving && error) {
            this.deleting = false;
          }
        });
    }
  }

  closeModal() {
    const modalEl = document.getElementById('propertyImageModal');
    if (modalEl) {
      const modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
      modal.hide();
    }
  }

  openDeleteModal() {
    const modalEl = document.getElementById('deleteConfirmModal');
    const modal = new bootstrap.Modal(modalEl!);
    modal.show();
  }

  closeDeleteModal() {
    const modalEl = document.getElementById('deleteConfirmModal');
    if (modalEl) {
      const modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
      modal.hide();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
